import React from "react";
import { useTranslation } from "react-i18next";
import "./footer.css";

const Footer = ({ className }) => {
  const { t: translator } = useTranslation();
  return (
    <footer className={`footer bg-dark ${className}`}>
      <div className="d-flex justify-content-between">
        <span className="text-white pl-4">
          {translator("Footer-UserSupport")}: 0800 0005
        </span>
        <span className="text-white mr-4">
          &copy; Combis {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
};
export default Footer;
